import { addDays, endOfToday, startOfToday } from 'date-fns';

import IB_Preset, { Custom_Preset } from '@bo-ibSheet/common';

export const EXHIBITION_ANCHOR_LIST = [
  { anchorName: '기본정보' },
  { anchorName: '사이트/계열사' },
  { anchorName: '상품그룹' },
  { anchorName: '메모' },
];

export const INTEGRATION_EXHIBITION_ANCHOR_LIST = [
  { anchorName: '기본정보' },
  { anchorName: '사이트/계열사' },
  { anchorName: '기획전/이벤트' },
  { anchorName: '메모' },
];

export const ALLIANCE_EXHIBITION_ANCHOR_LIST = [
  { anchorName: '기본정보' },
  { anchorName: '사이트/계열사' },
  { anchorName: '배너' },
  { anchorName: '메모' },
];

export const TAB_COLOR_CODE_LIST = [
  '141415',
  '5A5A5A',
  '999999',
  '3A08FF',
  '0487FF',
  '83C3FF',
  '6C60FF',
  '7F5AE8',
  'B29FFF',
  'F749A1',
  'D783FF',
  'F374B7',
  'E41C40',
  'D35666',
  'F65C60',
  '138C52',
  '00A89A',
  '8BC34A',
];

export const STAT_KEY = {
  DISPLAY_YN: 'displayYn',
  MAIN_DISPLAY_YN: 'mainDisplayYn',
  USE_YN: 'useYn',
  EXHIBITION_STATUS: 'exhibitionStatus',
  PERIOD_STATUS: 'periodStatus',
  EXHIBITION_DIVISION: 'exhibitionDivision',
  EXHIBITION_TYPE: 'exhibitionType',
  EVENT_TYPE: 'eventType',
};
export const SEARCH_CONDITIONS = [
  STAT_KEY.DISPLAY_YN,
  STAT_KEY.MAIN_DISPLAY_YN,
  STAT_KEY.USE_YN,
  STAT_KEY.EXHIBITION_STATUS,
  STAT_KEY.PERIOD_STATUS,
  STAT_KEY.EXHIBITION_DIVISION,
  STAT_KEY.EXHIBITION_TYPE,
];
export const SEARCH_PERIODS = [
  { name: '오늘', value: '1-days' },
  { name: '1주일', value: '1-weeks' },
  { name: '15일', value: '15-days' },
  { name: '1개월', value: '1-months' },
  { name: '3개월', value: '3-months' },
  { name: '6개월', value: '6-months' },
  { name: '1년', value: '12-months' },
  { name: '전체', value: 'all' },
];
export const SEARCH_KEYS = {
  /* 검색어 */
  searchKeywordTypeItems: [
    {
      key: 'exhibitionName',
      label: '기획전명',
      value: '기획전명',
    },
    {
      key: 'exhibitionNumber',
      label: '기획전번호',
      value: '기획전번호',
    },
  ],
  searchEventKeywordTypeItems: [
    {
      key: 'eventName',
      label: '이벤트명',
      value: '이벤트명',
    },
    {
      key: 'eventNumber',
      label: '이벤트번호',
      value: '이벤트번호',
    },
  ],
  /* 기간 */
  periodTypeItems: [
    {
      key: 'startDate',
      label: '시작일',
      value: '시작일',
    },
    {
      key: 'endDate',
      label: '종료일',
      value: '종료일',
    },
    {
      key: 'createDate',
      label: '등록일',
      value: '등록일',
    },
    {
      key: 'updateDate',
      label: '최종수정일',
      value: '최종수정일',
    },
  ],
  /* 기획전 상태 */
  exhibitionStatusItems: [
    { value: '10', labelText: '임시저장' },
    { value: '20', labelText: '등록완료' },
  ],
  /* 기간 상태 */
  periodStatusItems: [
    { value: 'before', labelText: '기간 전' },
    { value: 'ing', labelText: '기간 중' },
    { value: 'done', labelText: '기간 종료' },
  ],
  /* 기획전 구분 */
  exhibitionDivisionItems: [
    { value: '10', labelText: '단일' },
    { value: '20', labelText: '통합' },
    { value: '30', labelText: '제휴' },
  ],
  /* 기획전 유형 */
  exhibitionTypeItems: [
    { value: '30', labelText: '할인' },
    { value: '20', labelText: 'MD PICK' },
    { value: '10', labelText: 'MD 콘텐츠' },
  ],
  eventTypeItems: [
    { value: '10', labelText: '출석체크형' },
    { value: '20', labelText: '응모형(단순응모)' },
    { value: '21', labelText: '응모형(구매사은)' },
    { value: '30', labelText: '상품리뷰형' },
    { value: '40', labelText: '댓글형' },
    { value: '90', labelText: '기본형' },
  ],
  /* 사용 상태 */
  useYnItems: [
    { value: 'Y', labelText: '사용' },
    { value: 'N', labelText: '미사용' },
  ],
  /* 전시 상태 */
  displayYnItems: [
    { value: 'Y', labelText: '전시' },
    { value: 'N', labelText: '미전시' },
  ],
  /* 메인전시 상태 */
  mainDisplayYnItems: [
    { value: 'Y', labelText: '전시' },
    { value: 'N', labelText: '미전시' },
  ],
};

export const UPDATE_KEYS = {
  useYnItems: [
    {
      key: 'Y',
      label: '사용',
      disabled: false,
    },
    {
      key: 'N',
      label: '미사용',
      disabled: false,
    },
  ],
  displayYnItems: [
    {
      key: 'Y',
      label: '전시',
      disabled: false,
    },
    {
      key: 'N',
      label: '미전시',
      disabled: false,
    },
  ],
  mainDisplayYnItems: [
    {
      key: 'Y',
      label: '전시',
      disabled: false,
    },
    {
      key: 'N',
      label: '미전시',
      disabled: false,
    },
  ],
  exhibitionDivisionItems: [
    { key: '10', label: '단일기획전', disabled: false },
    { key: '20', label: '통합기획전', disabled: false },
    { key: '30', label: '제휴기획전', disabled: false },
  ],
};

export const EXHIBITION_DIVISION = {
  10: '단일기획전',
  20: '통합기획전',
  30: '제휴기획전',
};

export const EXHIBITION_STATUS = {
  10: '임시저장',
  20: '등록완료',
};

export const PERIOD_STATUS_CODE = {
  BEFORE: 'before',
  ING: 'ing',
  DONE: 'done',
};

export const EXHIBITION_STATUS_CODE = {
  TEMP_SAVE: '10',
  SUBMIT: '20',
};

export const EXHIBITION_DIVISION_CODE = {
  SINGLE: '10',
  INTEGRATION: '20',
  ALLIANCE: '30',
};

export const EXHIBITION_TYPE_CODE = {
  SALE: '30',
  MD_PICK: '20',
  MD_CONTENTS: '10',
};

export const ISPE_CMPS_DIVISION_CODE = {
  EXHIBITION: '10',
  EVENT: '20',
};

export const ISPE_CMPS_DIVISION = {
  10: '기획전',
  20: '이벤트',
};

export const BASIC_INFO_OPTIONS = {
  default: { label: '선택', value: '', key: 'default' },
  exhibitionDivision: [
    { key: '10', label: '단일기획전' },
    { key: '20', label: '통합기획전' },
    { key: '30', label: '제휴기획전' },
  ],
  exhibitionTypeOptions: [
    {
      key: '30',
      label: '할인',
      value: '30',
    },
    {
      key: '10',
      label: 'MD 컨텐츠',
      value: '10',
    },
    {
      key: '20',
      label: 'MD PICK',
      value: '20',
    },
  ],
  useYnOptions: [
    { key: 'useYn-Y', label: '사용', value: 'Y' },
    { key: 'useYn-N', label: '미사용', value: 'N' },
  ],
  dispYnOptions: [
    { key: 'dispYn-Y', label: '전시', value: 'Y' },
    { key: 'dispYn-N', label: '미전시', value: 'N' },
  ],
  registerYnOptions: [
    { key: 'regYn-Y', label: '등록', value: 'Y' },
    { key: 'regYn-N', label: '미등록', value: 'N' },
  ],
  goodGroupOptions: [
    { key: 'goodGrp-10', label: '단일상품그룹', value: '10' },
    { key: 'goodGrp-20', label: '복합상품그룹', value: '20' },
  ],
  mdPickMainLayoutOptions: [
    { key: 'mdPickLayout-10', label: '4개 (Best1 + 상품3)', value: '10' },
    { key: 'mdPickLayout-20', label: '5개 (Best1 + 상품4)', value: '20' },
    { key: 'mdPickLayout-30', label: '7개 (Best1 + 상품6)', value: '30' },
  ],
};

export const GOOD_GROUP_OPTIONS = {
  goodLayout: [
    { key: 'goodGroupLayout-10', label: '1단', value: '10' },
    { key: 'goodGroupLayout-20', label: '2단', value: '20' },
    { key: 'goodGroupLayout-30', label: '3단', value: '30' },
    { key: 'goodGroupLayout-40', label: '4단', value: '40' },
    { key: 'goodGroupLayout-60', label: '6단', value: '60' },
  ],
};

export const INITIAL_BASIC_INFO = {
  siteIncExc: 'all',
  familySale: false,
  siteSubsidiaryList: [],
  divisionCode: '10',
  status: '',
  speNo: '',
  mdId: '',
  mdName: '',
  typeCode: '',
  useYn: 'N',
  displayYn: 'N',
  mainDisplayYn: 'N',
  name: '',
  subName: '',
  mainDisplayName: '',
  mainDisplaySubName: '',
  startDate: startOfToday(),
  endDate: addDays(endOfToday(), 6),
  goodRegYn: 'N',
  goodGroupDivisionCode: '10', // 10: 단일상품그룹, 20: 복합상품그룹
  standardCategoryList: [],
  mainCategory: '',
  subCategoryList: [],
  badgeName01: '',
  badgeName02: '',
  mainExposeGoodCountCode: '10',
  hashtag: [],
  commImagePath: '',
  pcImagePath: '',
  mobileImagePath: '',
  memoContents: '',
  pcContents: '',
  mobileContents: '',
  pcMobileContentsCopyYn: 'N',
};

export const INITIAL_GOOD_GROUP_INFO = {
  sequence: '',
  name: '',
  layoutCode: '',
  pcContents: '',
  mobileContents: '',
  displayYn: 'N',
  pcMobileContentsCopyYn: 'N',
  goodList: [],
};

export const INITIAL_BANNER_GROUP_INFO = {
  speBannerGrpNo: '',
  bannerGrpDispSeq:'',
  speBannerGrpNm: '',    
  dispYn: 'N',  
  bannerList: [],
};



export const EXHIBITION_BASE_URL = '/promo/exhibition';
export const INTEGRATION_EXHIBITION_BASE_URL = `${EXHIBITION_BASE_URL}/integration`;
export const ALLIANCE_EXHIBITION_BASE_URL = `${EXHIBITION_BASE_URL}/alliance`;

export const EVENT_POPUP_OPTION = {
  Def: {
    Row: {
      CanFormula: 1,
      CalcOrder: 'periodStatus,periodStatusTextColor',
      Height: 44,
    },
  },
  LeftCols: [
    Custom_Preset.CheckBox,
    Custom_Preset.RowIndex,
    {
      ...Custom_Preset.ClipboardText,
      Cursor: 'default',
      TextStyle: 0,
      Header: '이벤트번호',
      Type: 'Text',
      Name: 'eventNumber',
      MinWidth: 60,
      Tip: 1,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    {
      Header: '이벤트명',
      Type: 'Text',
      Name: 'eventName',
      MinWidth: 100,
      Width: 180,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Left',
    },
  ],
  Cols: [
    {
      Header: '이벤트유형',
      Type: 'Text',
      Name: 'typeName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '사용상태',
      Type: 'Text',
      Name: 'useYn',
      Format: { Y: "<div style='color:#333333'>사용</div>", N: "<div style='color:#E10808'>미사용</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '전시상태',
      Type: 'Text',
      Name: 'displayYn',
      Format: { Y: "<div style='color:#333333'>전시</div>", N: "<div style='color:#E10808'>미전시</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    Custom_Preset.ListPeriodListStatus,
    {
      Header: '전시시작일',
      ...IB_Preset.LOCAL_DATE_TIME_YMD,
      Name: 'displayStartDate',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    {
      Header: '전시종료일',
      ...IB_Preset.LOCAL_DATE_TIME_YMD,
      Name: 'displayEndDate',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    Custom_Preset.CreateDate,
    {
      Header: '등록자',
      Type: 'Text',
      Name: 'creatorName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      Align: 'Center',
    },
  ],
};
export const INTEGRATION_EXHIBITION_POPUP_OPTION = {
  Def: {
    Row: {
      CanFormula: 1,
      CalcOrder: 'periodStatus,periodStatusTextColor',
      Height: 44,
    },
  },
  LeftCols: [
    Custom_Preset.CheckBox,
    Custom_Preset.RowIndex,
    {
      ...Custom_Preset.ClipboardText,
      Cursor: 'default',
      TextStyle: 0,
      Header: '기획전번호',
      Type: 'Text',
      Name: 'speNo',
      MinWidth: 60,
      Tip: 1,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    {
      Header: '기획전명',
      Type: 'Text',
      Name: 'name',
      MinWidth: 100,
      Width: 180,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Left',
    },
  ],
  Cols: [
    {
      Header: '기획전상태',
      Type: 'Text',
      Name: 'statusName',
      MinWidth: 100,
      Width: 100,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '기획전구분',
      Type: 'Text',
      Name: 'divisionName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '기획전유형',
      Type: 'Text',
      Name: 'exhibitionType',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '사용상태',
      Type: 'Text',
      Name: 'useYn',
      Format: { Y: "<div style='color:#333333'>사용</div>", N: "<div style='color:#E10808'>미사용</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '전시상태',
      Type: 'Text',
      Name: 'displayYn',
      Format: { Y: "<div style='color:#333333'>전시</div>", N: "<div style='color:#E10808'>미전시</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '메인전시상태',
      Type: 'Text',
      Name: 'mainDisplayYn',
      Format: { Y: "<div style='color:#333333'>전시</div>", N: "<div style='color:#E10808'>미전시</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    Custom_Preset.ListPeriodListStatus,
    {
      Header: '시작일',
      ...IB_Preset.LOCAL_DATE_TIME_YMD,
      Name: 'startDate',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    {
      Header: '종료일',
      ...IB_Preset.LOCAL_DATE_TIME_YMD,
      Name: 'endDate',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    Custom_Preset.CreateDate,
    {
      Header: '등록자',
      Type: 'Text',
      Name: 'creatorName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      Align: 'Center',
    },
    {
      Header: '담당MD',
      Type: 'Text',
      Name: 'mdName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      Align: 'Center',
    },
  ],
};

export const INTEGRATION_EXHIBITION_POPUP_OPTION_ONE_SEL = { //한개의 레코드만 선택할 수 있도록 한다.
  Def: {
    Row: {
      CanFormula: 1,
      CalcOrder: 'periodStatus,periodStatusTextColor',
      Height: 44,
    },
  },
  LeftCols: [
    {
      Header: { Value: '', Align: 'Center', HeaderCheck: 0 }, //HeaderCheck: 0 헤드row에서 전체선택을 제거한다.
      Type: 'Bool',
      Name: 'CHK',
      Align: 'Center',
      Width: 60,
      MaxWidth: 60,
      CanSort: false,
      CanExport: false,
      ColMerge: false,
      NoChanged: true,
      BoolGroup: 1 //한개만 선택 가능 하도록 하는 옵션
    },
    Custom_Preset.RowIndex,
    {
      ...Custom_Preset.ClipboardText,
      Cursor: 'default',
      TextStyle: 0,
      Header: '기획전번호',
      Type: 'Text',
      Name: 'speNo',
      MinWidth: 60,
      Tip: 1,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    {
      Header: '기획전명',
      Type: 'Text',
      Name: 'name',
      MinWidth: 100,
      Width: 180,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Left',
    },
  ],
  Cols: [
    {
      Header: '기획전상태',
      Type: 'Text',
      Name: 'statusName',
      MinWidth: 100,
      Width: 100,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '기획전구분',
      Type: 'Text',
      Name: 'divisionName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '기획전유형',
      Type: 'Text',
      Name: 'exhibitionType',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '사용상태',
      Type: 'Text',
      Name: 'useYn',
      Format: { Y: "<div style='color:#333333'>사용</div>", N: "<div style='color:#E10808'>미사용</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '전시상태',
      Type: 'Text',
      Name: 'displayYn',
      Format: { Y: "<div style='color:#333333'>전시</div>", N: "<div style='color:#E10808'>미전시</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    {
      Header: '메인전시상태',
      Type: 'Text',
      Name: 'mainDisplayYn',
      Format: { Y: "<div style='color:#333333'>전시</div>", N: "<div style='color:#E10808'>미전시</div>" },
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 0,
      Align: 'Center',
    },
    Custom_Preset.ListPeriodListStatus,
    {
      Header: '시작일',
      ...IB_Preset.LOCAL_DATE_TIME_YMD,
      Name: 'startDate',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    {
      Header: '종료일',
      ...IB_Preset.LOCAL_DATE_TIME_YMD,
      Name: 'endDate',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      CanSort: 1,
      Align: 'Center',
    },
    Custom_Preset.CreateDate,
    {
      Header: '등록자',
      Type: 'Text',
      Name: 'creatorName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      Align: 'Center',
    },
    {
      Header: '담당MD',
      Type: 'Text',
      Name: 'mdName',
      MinWidth: 100,
      Width: 120,
      CanEdit: 0,
      Align: 'Center',
    },
  ],
};
